import React from "react";
import { ReactComponent as CloseIcon } from "static/images/close.svg";
import { noop } from "lib/utils";

import PromoForm from "./PromoForm";

import "styles/components/promo.scss";

const ModalPassengersForm = ({
  onClose = noop,
  onChange = noop,
  promoCode,
}) => {
  return (
    <div className="otrl-jp__modal-promo-form">
      <div className="otrl-jp__modal-promo-form__header">
        <div
          className="otrl-jp__modal-promo-form__header__bar"
          onClick={onClose}
        >
          <button
            className="otrl-jp__modal-promo-form__close otrl-jp__button-unstyled"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className="otrl-jp__modal-promo-form__wrapper">
        <PromoForm onChange={onChange} promoCode={promoCode} />
      </div>

      {promoCode && (
        <button
          className="otrl-jp__button otrl-jp__promo-form__button otrl-jp__button--full-width"
          onClick={onClose}
          type="button"
        >
          Done
        </button>
      )}
    </div>
  );
};

export default ModalPassengersForm;
